import { ProductListQuery } from 'Query/ProductList.query';

import { Field } from 'Util/Query';

export class BuyTogetherQuery extends ProductListQuery {
    getProducts(products) {
        return new Field('getGroupProducts')
            .addArgument('products_sku', '[String]', products)
            .addFieldList([this.getProductsInfo()])
    }

    getProductsInfo() {
        return new Field('products')
            .addFieldList([
                'id',
                'sku',
                'name',
                'url',
                this._getPriceRangeField(),
                this._getProductSmallField(),
                new Field('cartRuleSpecialPriceData')
                    .addFieldList([
                        'price',
                        'startDate',
                        'endDate',
                        'sticker_text',
                        'sticker_background_color',
                        'sticker_text_color'
                    ]),
                'inStock'
            ]);
    }

    addProducts(input) {
        return new Field('saveGroupProducts')
            .addArgument('input', 'saveGroupProductsInput!', input)
            .addFieldList(['status'])
    }
}

export default new BuyTogetherQuery();
